import { catchError } from 'rxjs/operators';
// Custom packages
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./helper.service";
import * as i3 from "ngx-cookie-service";
var VideoViewService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function VideoViewService(apiService, helperService, cookieService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.cookieService = cookieService;
    }
    /**
     * Create a new video view
     *
     * @since 1.0.0
     *
     * @param data VideoView data
     */
    VideoViewService.prototype.create = function (data) {
        return this.apiService.apiCall('POST', 'videos-views', data);
    };
    /**
     * Get videos views list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    VideoViewService.prototype.getSuppliersVideoList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "videos-views/suppliers/" + companyId, params);
    };
    /**
     * Get videos views list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    VideoViewService.prototype.getResidentsVideoList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "videos-views/residents/" + companyId, params);
    };
    /**
     * Get an exportation file of supplier type of videos views of the company
     *
     * @since 1.0.0
     */
    VideoViewService.prototype.getSuppliersVideoExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "videos-views/suppliers-export/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of resident type of videos views of the company
     *
     * @since 1.0.0
     */
    VideoViewService.prototype.getResidentsVideoExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "videos-views/residents-export/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    VideoViewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VideoViewService_Factory() { return new VideoViewService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.CookieService)); }, token: VideoViewService, providedIn: "root" });
    return VideoViewService;
}());
export { VideoViewService };
